"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDesktopHeaderContainer = exports.MobileHeaderContent = exports.MobileHeaderContainer = exports.StyledButtonWithIcon = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = require("@kyruus/button");
exports.StyledButtonWithIcon = (0, styled_1.default)(button_1.ButtonWithIcon) `
  display: flex;
  align-items: center;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0px;
  padding-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  width: fit-content;
`;
exports.MobileHeaderContainer = styled_1.default.div `
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  z-index: 100;
  width: 100%;
  position: sticky;
  top: 0;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} ${(0, ui_theme_1.fromTheme)('spacing_large')};
  display: flex;
  justify-content: flex-start;
  border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
`;
exports.MobileHeaderContent = styled_1.default.div `
  display: flex;
  align-items: center;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  button {
    padding: 0;
    svg:first-of-type {
      left: 0;
      color: ${(0, ui_theme_1.fromTheme)('color_text')};
    }
  }
`;
exports.StyledDesktopHeaderContainer = styled_1.default.div `
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  z-index: 9999;
  position: sticky;
  top: 0;
`;
//# sourceMappingURL=styles.js.map